<div class="overflow-auto w-full h-full min-h-screen bg-gray-50 font-prompt flex flex-col">
  <header
    class="sticky top-0 z-30 bg-(--header-background) px-4 py-2.5 flex items-center gap-2.5 min-h-[56px]"
  >
    <button
      *ngIf="header().backLink"
      type="button"
      (click)="goBack()"
      aria-label="ย้อนกลับ"
      class="w-9 h-9 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center shrink-0 border-0 cursor-pointer transition"
    >
      <img src="/icons/arrow_back_white.svg" alt="" class="w-5 h-5" />
    </button>

    <img
      *ngIf="!header().backLink; else pageTitle"
      src="/images/element-24.png"
      alt="City Parking"
      class="h-8 object-contain"
    />
    <ng-template #pageTitle>
      <h1 class="text-[15px] font-extrabold text-white truncate m-0">{{ header().title }}</h1>
    </ng-template>
  </header>

  <main class="flex-1 w-full max-w-lg mx-auto px-4 py-5 pb-20">
    <router-outlet></router-outlet>
  </main>
</div>
